var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"timing"},[_vm._v(_vm._s(_setup.formattedTime))])
}
var staticRenderFns = []

export { render, staticRenderFns }